// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"082efd32","488":"e26da49a"}[chunkId] + ".chunk.js";
};